function showHiddenContentOnMob() {
    document.querySelectorAll("[data-show-content]").forEach((showBtn) => {
        showBtn.addEventListener("click", function (e) {
            const targetBox = e.currentTarget.dataset.showContent;

            document.querySelectorAll(`[data-show-full="${targetBox}"] .mob_hide`).forEach((el) => el.classList.remove("mob_hide"));
            e.currentTarget.remove();
        });
    });
}

  export {
    showHiddenContentOnMob
  }